import { HeroSection, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import { renderStringToReact, useTranslation } from '@web_opxp/features';
import React from 'react';
import { useSelector } from 'react-redux';
import { SKELETON_CLASSNAME, TRAINING_DOMAINS } from '../base/constants';
import { EDomain } from '../base/types';
import HintPopup from '../components/HintPopup/HintPopup';
import SideBarSection from '../components/SideBarSection/SideBarSection';
import { CyclesSelectors } from '../cycles';
import { GroupAdminBanner } from '../groupAdmin';
import './DomainEvaluationSubpage.scss';
import EvaluationSideBar from './EvaluationSideBar';
import TabSwitch from './TabSwitch';
import DomainEvaluationView from './domain-evaluation/DomainEvaluationView';
import * as Selectors from './selectors';
import useUserIdFromRoute from './useUserIdFromRoute';

export default function DomainEvaluationSubpage() {
  const [selectedDomain, setSelectedDomain] = React.useState<EDomain | null>(null);
  const userId = useUserIdFromRoute();
  const cyclesLoaded = !useSelector(CyclesSelectors.isCyclesLoading);
  const ready = useSelector(Selectors.isFeatureReady);
  const sessionsLeft = useSelector(CyclesSelectors.getSessionsLeftCount);
  const { language, t } = useTranslation();

  React.useEffect(() => {
    if (cyclesLoaded) {
      setSelectedDomain(1);
    }
  }, [cyclesLoaded]);

  const evaluationLottie = 'Lab_Animation360';
  const loaded = ready && !!language && cyclesLoaded;
  const skeletonClass = loaded ? '' : SKELETON_CLASSNAME;
  let subTitle = '';

  if (loaded) {
    if (userId && userId !== 0) {
      subTitle = t('Evaluation.UserIntro');
    } else {
      subTitle = t('Evaluation.Intro', { sessionsLeft });
    }
  }

  const domainSwitchDomains = [...TRAINING_DOMAINS];

  const buttonLabel = t('Evaluation.HintDialogOKLabel.Progress');
  const hintPopupTitle = t('Evaluation.HintDialogTitle.Progress');
  const hintPopupContent = t('Evaluation.HintContentHtml.Progress');

  const contentReactElement = renderStringToReact(hintPopupContent);
  const sidebar = <EvaluationSideBar />;
  return (
    <>
      <HeroSection lottie={evaluationLottie} className="evaluation-section">
        <SectionTitle className={skeletonClass}>{t('Evaluation.Title')}</SectionTitle>
        <SectionSubtitle className={skeletonClass + ' domain-evaluation-progress-subtitle'}>
          {subTitle}
          {userId ? null : (
            <HintPopup title={hintPopupTitle} iconSize={20} okButtonLabel={buttonLabel}>
              {contentReactElement}
            </HintPopup>
          )}
        </SectionSubtitle>
      </HeroSection>
      <GroupAdminBanner userId={userId} />
      <SideBarSection sidebar={sidebar}>
        <div className="col-2"></div>
        <div className="col-6 domain-evaluation-content">
          <TabSwitch
            tabs={domainSwitchDomains}
            titlePrefix="Evaluation.Domain.Title"
            onClick={setSelectedDomain}
            active={selectedDomain}
          />
          <DomainEvaluationView selectedDomain={selectedDomain} userId={userId} />
        </div>
        <div className="col-1"></div>
      </SideBarSection>
    </>
  );
}
